import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadablePartnerClientDetail = Loadable({
  loader: function loader() {
    return import('../Partners/PartnerClientDetail.jsx');
  },
  loading: ComponentLoading
});
export default LoadablePartnerClientDetail;